import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/gym/$venueUuid/loyalty/quests/$questUuid/profile/")({
  loader: () => {
    throw redirect({
      to: "./details",
      from: "/gym/$venueUuid/loyalty/quests/$questUuid/profile/",
      replace: true,
    });
  },
});
